import { render, staticRenderFns } from "./PollRating.vue?vue&type=template&id=2dbbd3dd&scoped=true&"
import script from "./PollRating.vue?vue&type=script&lang=js&"
export * from "./PollRating.vue?vue&type=script&lang=js&"
import style0 from "./PollRating.vue?vue&type=style&index=0&id=2dbbd3dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbbd3dd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRating } from 'vuetify/lib/components/VRating';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRating,VTooltip})
